import { render, staticRenderFns } from "./ManageCancellation.vue?vue&type=template&id=682d3961&scoped=true&"
import script from "./ManageCancellation.vue?vue&type=script&lang=js&"
export * from "./ManageCancellation.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=682d3961&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682d3961",
  null
  
)

export default component.exports